module.exports = __webpack_public_path__ + "img/icon_checklist.bafcf2dd.jpg";